// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__bq8f6","modalBody":"StaffClientsModal_modalBody__NHJYS","formControl":"StaffClientsModal_formControl__lBasu"};